class SwiperSlider extends HTMLElement {
  constructor() {
    super();

    this.init = false;
    this.swiper = null;

    window.addEventListener("load", this.initSlider.bind(this));
    window.addEventListener("resize", this.initSlider.bind(this));
  }

  initSlider() {
    let desktop = window.matchMedia("(min-width: 768px)");

    if (desktop.matches) {
      if (this.init === false) {
        this.init = true;

        this.swiper = new Swiper(".swiper", {
          slidesPerView: 4,
          spaceBetween: 50,
          loop: true,
          pagination: {
            el: ".swiper-pagination",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
          },
        });
      }
    } else {
      if (this.init === true) {
        this.swiper.destroy();
        this.init = false;
      }
    }
  }
}
customElements.define("swiper-slider", SwiperSlider);
